import {useMainStore} from '@/store/main';
import {toast} from 'vue3-toastify';
import axios from 'axios';

// список пород не меняется за время визита: грузим один раз на вид животного
const breedsCache = {};

export const useApi = () => {
	const mainStore = useMainStore();

	const getBreeds = value => {
		breedsCache[value] ??= axios
			.get(`/api/breeds?animal_kind=${value}`)
			.then(response => response.data.data)
			.catch(() => {
				delete breedsCache[value];
				console.log('error');
			});

		return breedsCache[value];
	};

	const sendCallback = async (tel, name, comment) => {
		try {
			const response = await axios.post(`/api/sendCallback`, {
				tel,
				name,
				comment
			});
			return response.data.data;
		} catch ({response}) {
			console.log('error');
			toast.error('Произошла ошибка', {
				position: toast.POSITION.BOTTOM_RIGHT,
				autoClose: 13000,
			});
		}
	};

	const getServices = async value => {
		try {
			const response = await axios.get(`/api/services?breed_id=${value}`);
			return response.data.data;
		} catch ({response}) {
			console.log('error');
		}
	};

	const getMasters = async value => {
		try {
			const response = await axios.get(
				`/api/masters?service_id=${value}`,
			);
			return response.data.data;
		} catch ({response}) {
			console.log('error');
		}
	};

	const getReviews = async value => {
		try {
			const response = await axios.get(`/api/masters/${value}/reviews`);
			return response.data.data;
		} catch ({response}) {
			console.log('error');
		}
	};

	const setReviews = async (master_id, formData) => {
		try {
			await axios.post(`/api/masters/${master_id}/reviews`, formData);

			toast.success('Успешная отправка', {
				position: toast.POSITION.BOTTOM_RIGHT,
				autoClose: 13000,
			});
		} catch {
			console.log('error');
			toast.error('Произошла ошибка', {
				position: toast.POSITION.BOTTOM_RIGHT,
				autoClose: 13000,
			});
		}
	};

	const getTimeShedule = async ({id, service_ids, date}) => {
		try {
			const servicesString = service_ids
				.map(el => `service_ids=${el}`)
				.join('&');
			const response = await axios.get(
				`/api/masters/${id}/schedule?${servicesString}&date=${date}`,
			);
			return response.data.data;
		} catch ({response}) {
			console.log('error');
		}
	};

	const setDraft = async (draft, pet) => {
		try {
			let response;
			const formData = new FormData();

			// массив целиком FormData превращает в "1,2" — сервер такое не принимает
			Object.keys(draft).forEach(el => {
				if (el != 'services' && el != 'master') {
					if (Array.isArray(draft[el]))
						draft[el].forEach(elem => formData.append(el, elem));
					else formData.append(el, draft[el]);
				}
			});

			if (mainStore.sesson_id)
				formData.append('session_id', mainStore.sesson_id);

			if (pet.pet_id) formData.append('pet_id', pet.pet_id);

			response = await axios.post(`/api/drafts`, formData);

			return response.data.data;
		} catch ({response}) {
			toast.error(response?.data?.errors?.other?.[0] || 'Произошла ошибка', {
				position: toast.POSITION.BOTTOM_RIGHT,
				autoClose: 13000,
			});
			console.log('error');
		}
	};

	const updateDraft = async (draft, pet) => {
		const mainStore = useMainStore();

		try {
			let response;
			const formData = new FormData();

			Object.keys(draft).forEach(el => {
				if (el != 'services' && el != 'master') {
					if (Array.isArray(draft[el]))
						draft[el].forEach(elem => formData.append(el, elem));
					else formData.append(el, draft[el]);
				}
			});

			response = await axios.post(
				`/api/drafts/${mainStore.sesson_id}/${pet.pet_id}/${draft.draft_id}`,
				formData,
			);
			return response.data.data;
		} catch ({response}) {
			toast.error(response?.data?.errors?.other?.[0] || 'Не удалось сохранить изменения', {
				position: toast.POSITION.BOTTOM_RIGHT,
				autoClose: 13000,
			});
			console.log('error');
		}
	};

	const deletePet = async formData => {
		try {
			await axios.delete(`/api/drafts/pets/${formData.pet_id}`);
			formData.drafts = [];
			delete formData.pet_id;
		} catch ({response}) {
			toast.error('Произошла ошибка', {
				position: toast.POSITION.BOTTOM_RIGHT,
				autoClose: 13000,
			});
			console.log('error');
		}
	};

	const deleteDraft = async (pet_id, draft_id) => {
		try {
			await axios.delete(
				`/api/drafts/${mainStore.sesson_id}/${pet_id}/${draft_id}`,
			);
		} catch ({response}) {
			toast.error('Произошла ошибка', {
				position: toast.POSITION.BOTTOM_RIGHT,
				autoClose: 13000,
			});
			console.log('error');
		}
	};

	const updatePhotos = async (pet_id, photoArray) => {
		try {
			const formData = new FormData();
			photoArray.forEach(el => formData.append('photos', el));
			if (pet_id)
				await axios.post(`/api/pets/${pet_id}/photos`, formData);
		} catch ({response}) {
			toast.error('Произошла ошибка', {
				position: toast.POSITION.BOTTOM_RIGHT,
				autoClose: 13000,
			});
			console.log('error');
		}
	};

	const setAppointment = async formData => {
		try {
			return await axios.post(`/api/appointments`, formData);
		} catch ({response}) {
			toast.error('Произошла ошибка', {
				position: toast.POSITION.BOTTOM_RIGHT,
				autoClose: 13000,
			});
			console.log('error');
		}
	};

	const cancelOrder = async (session_id, event_id) => {
		try {
			if (session_id && event_id) {
				await axios.delete(`/api/appointments/${session_id}/${event_id}`);
			} else throw new Error('error');
		} catch (e) {
			toast.error('Произошла ошибка', {
				position: toast.POSITION.BOTTOM_RIGHT,
				autoClose: 13000,
			});
			console.log('error');
			throw e;
		}
	};

	const getMaster = async id => {
		try {
			const response = await axios.get(`/api/masters/${id}`);
			return response.data.data;
		} catch (e) {
			console.error(e);
		}
	};

	return {
		setDraft,
		deletePet,
		getBreeds,
		getMaster,
		getMasters,
		getReviews,
		setReviews,
		deleteDraft,
		getServices,
		cancelOrder,
		updateDraft,
		updatePhotos,
		sendCallback,
		getTimeShedule,
		setAppointment,
	};
};
